import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from 'react';
export const ExpandCollapseComponentSVG = (props) => {
    const children = props.adapter.getFilteredChildren(props.item);
    let toDisplay;
    if (children.length === 0)
        toDisplay = '';
    else if (!props.expanded)
        toDisplay = _jsx("svg", { width: "15", height: "15", viewBox: "0 0 15 15", fill: "currentColor", style: { color: '#9b59b6' }, children: _jsx("path", { d: "M0 14l6-6-6-6z" }) });
    else
        toDisplay = _jsx("svg", { width: "15", height: "15", viewBox: "0 0 15 15", fill: "currentColor", style: { color: '#3498db' }, children: _jsx("path", { d: "M0 5l6 6 6-6z" }) });
    return _jsx("div", { className: `clickable`, onClick: props.expandToggler, style: { width: '15px', marginRight: 2 }, children: toDisplay });
};
export class Example_ColorfulNodeRenderer extends React.Component {
    constructor(props) {
        super(props);
    }
    render() {
        const valueStyle = (_value) => {
            switch (typeof _value) {
                case 'string':
                    return { color: '#e67e22' };
                case 'boolean':
                    return { color: '#bf95d0' };
                case 'number':
                    if (isNaN(_value))
                        return { color: '#e0e0e0' };
                    return { color: '#2ecc71' };
                case 'undefined':
                    return { color: '#000' };
                case 'object':
                    if (_value === null)
                        return { color: '#f1c40f' };
                // eslint-disable-next-line no-fallthrough
                default:
                    return { color: '#000000' };
            }
        };
        let value;
        const item = this.props.item;
        if (typeof item !== 'object' || item === undefined || item === null)
            value = `${item}`;
        else if (Array.isArray(item))
            value = '[]';
        else if (Object.keys(item).length === 0)
            value = '{}';
        else
            value = '';
        const nameStyle = { color: '#000000' };
        return (_jsxs("div", { className: "ll_h_c", children: [_jsx(ExpandCollapseComponentSVG, { ...this.props.node }), _jsxs("div", { children: [_jsx("span", { style: nameStyle, children: this.props.node.propKey }), value !== '' ? ': ' : '', _jsx("span", { style: valueStyle(value), children: `${value}` })] })] }));
    }
}
